<style lang="stylus" scoped>
    .promodal
        position absolute
        left 0
        top 0
        width 100vw
        height 100vh
        z-index 999
        .promodal-mask
            position absolute
            left 0
            top 0
            width 100vw
            height 100vh
            background rgba(0,0,0,0.4)
        .iframe-box
            position absolute
            left 50%
            top 50%
            transform translate(-50%, -50%)
            width 740px
            box-shadow 0px 15px 30px 0px #00000026
            border-radius 8px
            iframe
                border none
                width 100%
                height 100%
</style>

<template>
    <div class="promodal">
        <div class="promodal-mask"></div>
        <div class="iframe-box" :style="{ height: `${boxHeight}px` }">
            <iframe ref="iframeWin" :src="iframeUrl" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import { EDRAWMAX_PRODUCT_ENV } from "@/env/";

    @Component
    export default class Promodal extends Vue {
        @Prop()
        page;
        @Prop()
        type;

        get userInfo() {
            return this.$store.getters.apiParam;
        }
        get iframeUrl() {
            const url = /dev.edrawmax/.test(location.host) ? "https://wmp.edrawsoft.cn/promodal/" : "https://www.edrawmax.com/promodal/";
            return `${url}?page=${this.page}&type=${this.type}&uid=${this.userInfo.id}&lang=${this.lang}${this.vipSuffix}`;
        }
        get vipSymbolMark() {
            return this.$store.state.vipState?.vipSymbolMark;
        }
        get vipTemplateMark() {
            return this.$store.state.vipState?.vipTemplateMark;
        }
        get vipShapeNum() {
            return this.$store.state.vipState?.vipShapeNum;
        }
        get cummunityVipTemplateMark() {
            return this.$store.state.vipState?.cummunityVipTemplateMark;
        }
        get vipPageTheme() {
            return this.$store.state.vipState.vipPageTheme;
        }
        get vipPageColor() {
            return this.$store.state.vipState.vipPageColor;
        }
        get vipPageConnect() {
            return this.$store.state.vipState.vipPageConnect;
        }
        get vipPageAutoBeautify() {
            return this.$store.state.vipState.vipPageAutoBeautify;
        }
        get vipPageBackground() {
            return this.$store.state.vipState.vipPageBackground;
        }
        get vipDoctWatermark() {
            return this.$store.state.vipState.vipDoctWatermark;
        }
        get vipDocPageNum() {
            return this.$store.state.vipState.vipDocPageNum;
        }
        get vipMath() {
            return this.$store.state.vipState.vipMath;
        }
        get vipPPTFont() {
            return this.$store.state.vipState.vipPPTFont;
        }
        get removeGrid() {
            return this.$store.state.ui?.removeGrid;
        }
        get triggerType() {
            return this.$store.state.ui?.triggerType;
        }
        get saveMathSymbol() {
            return this.$store.state.ui.saveMathSymbol;
        }
        get vipSuffix() {
            let str = "";
            let privileges = [];
            if (this.triggerType) {
                str += `&trigger=${this.triggerType}`;
                if (this.vipSymbolMark) {
                    privileges.push("Symbol");
                }
                if (this.vipTemplateMark || this.cummunityVipTemplateMark) {
                    privileges.push("Template");
                }
                if (this.vipShapeNum) {
                    privileges.push("ShapeNum");
                }
                if (!this.removeGrid) {
                    privileges.push("Remove Grid");
                }
                if (this.vipPageTheme) {
                    privileges.push("Theme");
                }
                if (this.vipPageColor) {
                    privileges.push("ThemeColor");
                }
                if (this.vipPageConnect) {
                    privileges.push("ThemeConnect");
                }
                if (this.vipPageAutoBeautify) {
                    privileges.push("Beautify");
                }
                if (this.vipPageBackground) {
                    privileges.push("PageBg");
                }
                if (this.vipDoctWatermark) {
                    privileges.push("Watermark");
                }
                if (this.vipDocPageNum) {
                    privileges.push("PageNum");
                }
                if (this.vipMath || this.triggerType == "formulaEditor") {
                    privileges.push("Math");
                }
                if (this.vipPPTFont) {
                    privileges.push("PPT");
                }
                if (privileges.length > 0) {
                    str += `&privileges=${privileges.join("_")}`;
                }
            }
            return str;
        }
        boxHeight = 0;
        messageHandle(e) {
            const key = e.data.key ? e.data.key.split("_") : [],
                params = e.data.params || [];
            let prefix = key[0] || "";
            if (prefix == "promodal") {
                const str = key[1];
                if (str == "openUrl") {
                    try {
                        window.open(params[0]);
                    } catch (error) {
                        // 唤起弹窗失败则更改当前页面url
                        location.href = params[0];
                    }
                } else if (str == "closewin") {
                    this.$emit("togglePromodal", false);
                    if (this.triggerType && this.userInfo.id && this.userInfo.id % 2) {
                        this.$bus.$emit("vipBtest");
                    }
                    if (!this.removeGrid) {
                        let view = window["_view"];
                        if (!view) return;
                        view.showGridBox(true);
                        this.$store.commit("setStatus", {
                            type: "removeGrid",
                            data: true,
                        });
                    }
                    if (this.saveMathSymbol) {
                        this.$store.commit("setStatus", {
                            type: "saveMathSymbol",
                            data: false,
                        });
                    }
                    this.$store.commit("setStatus", {
                        type: "triggerType",
                        data: "",
                    });
                } else if (str == "setHeight") {
                    this.boxHeight = params[0];
                } else if (str == "track") {
                    let obj = {
                        upgrade_trigger: this.$store.state.publicStore.upgradeTrigger,
                    };
                    if (params[0] == "newUpgradePlanTipPage2") {
                        Object.assign(obj, {
                            // ab_test: this.userInfo.id % 2 ? "b" : "a",
                            source: params[1]?.isBuyNow ? "clickBuyNow" : "clickFreeTrial",
                        });
                    }
                    this.sensors && this.sensors.track(params[0], obj);
                } else if (str == "trackShopCar") {
                    this.sensors &&
                        this.sensors.track("newUpgradePlanTipToShoppingCart", {
                            upgrade_trigger: this.$store.state.publicStore.upgradeTrigger,
                            plan: ["annualUnlimitedPlan", "monthlyUnlimitedPlan", "perpetualPlan"][params[0]],
                            source: params[1] ? "clickBuyNow" : "clickFreeTrial",
                            // ab_test: this.userInfo.id % 2 ? "b" : "a",
                        });
                }
            }
        }
        postMessageToFrame(msg) {
            (this.$refs.iframeWin as HTMLIFrameElement).contentWindow.postMessage(msg, "*");
        }
        mounted() {
            window.addEventListener("message", this.messageHandle);
        }
        beforeDestroy() {
            window.removeEventListener("message", this.messageHandle);
        }
    }
</script>
<i18n>
{
    "zh": {},
    "en": {},
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
